import { Link } from 'react-router-dom';
import MainLayout from '@/components/layout/MainLayout';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';

const TermsOfService = () => {
  return (
    <MainLayout>
      <div className="container mx-auto px-4 py-16">
        <div className="max-w-4xl mx-auto">
          <div className="mb-8">
            <Link to="/" className="inline-flex items-center text-slate-200 hover:text-slate-200/80 mb-4">
              <ArrowLeft className="h-4 w-4 mr-2" />
              Back to Home
            </Link>
            <h1 className="text-4xl font-bold text-slate-200 mb-4">Terms of Service</h1>
          </div>

          <div className="prose prose-lg max-w-none">
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-slate-200 mb-4">1. Acceptance of Terms</h2>
              <p className="text-slate-300 mb-4">
                By accessing and using Lobier's AI-powered hotel chatbot service ("Service"), you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-slate-200 mb-4">2. Description of Service</h2>
              <p className="text-slate-300 mb-4">
                Lobier provides an AI-powered chatbot service designed to assist hotels in answering guest inquiries automatically. The service includes:
              </p>
              <ul className="list-disc pl-6 text-slate-300 mb-4">
                <li>AI-powered conversation capabilities</li>
                <li>Multilingual support (English, Turkish, German, Russian)</li>
                <li>Customizable hotel information management</li>
                <li>Embeddable chat widget for hotel websites</li>
                <li>Analytics and reporting features</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-slate-200 mb-4">3. User Accounts and Registration</h2>
              <p className="text-slate-300 mb-4">
                To use our Service, you must register for an account. You agree to:
              </p>
              <ul className="list-disc pl-6 text-slate-300 mb-4">
                <li>Provide accurate and complete information</li>
                <li>Maintain the security of your account credentials</li>
                <li>Notify us immediately of any unauthorized use</li>
                <li>Accept responsibility for all activities under your account</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-slate-200 mb-4">4. Acceptable Use</h2>
              <p className="text-slate-300 mb-4">You agree not to use the Service to:</p>
              <ul className="list-disc pl-6 text-slate-300 mb-4">
                <li>Violate any applicable laws or regulations</li>
                <li>Infringe upon intellectual property rights</li>
                <li>Transmit harmful, offensive, or inappropriate content</li>
                <li>Attempt to gain unauthorized access to our systems</li>
                <li>Interfere with the proper functioning of the Service</li>
                <li>Use the Service for any commercial purpose not expressly permitted</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-slate-200 mb-4">5. Content and Data</h2>
              <h3 className="text-xl font-medium text-slate-200 mb-3">5.1 Your Content</h3>
              <p className="text-slate-300 mb-4">
                You retain ownership of the content you upload to our Service. By uploading content, you grant us a license to use, store, and process this content to provide the Service.
              </p>

              <h3 className="text-xl font-medium text-slate-200 mb-3">5.2 Data Processing</h3>
              <p className="text-slate-300 mb-4">
                We process your data in accordance with our Privacy Policy. You are responsible for ensuring you have the right to share any guest data with our Service.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-slate-200 mb-4">6. Service Availability</h2>
              <p className="text-slate-300 mb-4">
                We strive to maintain high service availability but cannot guarantee uninterrupted access. We may perform maintenance, updates, or modifications that temporarily affect service availability.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-slate-200 mb-4">7. Pricing and Payment</h2>
              <p className="text-slate-300 mb-4">
                Service pricing is subject to change with notice. You agree to pay all fees associated with your use of the Service. Payment terms and methods will be specified in your service agreement.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-slate-200 mb-4">8. Intellectual Property</h2>
              <p className="text-slate-300 mb-4">
                The Service and its original content, features, and functionality are owned by Lobier and are protected by international copyright, trademark, patent, trade secret, and other intellectual property laws.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-slate-200 mb-4">9. Disclaimers</h2>
              <p className="text-slate-300 mb-4">
                THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND. WE DISCLAIM ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-slate-200 mb-4">10. Limitation of Liability</h2>
              <p className="text-slate-300 mb-4">
                IN NO EVENT SHALL LOBIER BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, INCLUDING WITHOUT LIMITATION, LOSS OF PROFITS, DATA, USE, GOODWILL, OR OTHER INTANGIBLE LOSSES.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-slate-200 mb-4">11. Indemnification</h2>
              <p className="text-slate-300 mb-4">
                You agree to defend, indemnify, and hold harmless Lobier from and against any claims, damages, obligations, losses, liabilities, costs, or debt arising from your use of the Service.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-slate-200 mb-4">12. Termination</h2>
              <p className="text-slate-300 mb-4">
                We may terminate or suspend your account and access to the Service immediately, without prior notice, for any reason, including breach of these Terms. Upon termination, your right to use the Service will cease immediately.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-slate-200 mb-4">13. Governing Law</h2>
              <p className="text-slate-300 mb-4">
                These Terms shall be governed by and construed in accordance with the laws of [Your Jurisdiction], without regard to its conflict of law provisions.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-slate-200 mb-4">14. Changes to Terms</h2>
              <p className="text-slate-300 mb-4">
                We reserve the right to modify these Terms at any time. We will notify users of any material changes by posting the new Terms on this page and updating the "Last updated" date.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-slate-200 mb-4">15. Contact Information</h2>
              <p className="text-slate-300 mb-4">
                If you have any questions about these Terms of Service, please contact us at:
              </p>
              <div className="bg-slate-800 p-4 rounded-lg">
                <p className="text-slate-300">
                  <strong>Email:</strong> info@lobier.com
                </p>
              </div>
            </section>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default TermsOfService; 